import { Injectable, NgZone, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  snackBar = inject(MatSnackBar);
  private zone = inject(NgZone);

  open(message: string, action = 'OK', duration = 4000) {
    this.zone.run(() => {
      this.snackBar.open(message, action, { duration });
    });
  }
}
